import React from "react";

const Users = () => {
  return <div className="page-content">Users</div>;
};

export default Users;
